export default __webpack_public_path__ + "static/media/sales.b529f19e.svg";